import { z } from "zod";
import { WholeNumber_Schema } from "@/utilities/schema";

export enum CategoryId {
  LegoSets = 1,
  Alcohol = 3,
  Watches = 2,
  Shoes = 4,
  Art = 5,
  Furniture = 6,
  Jewellery = 7,
  Coins = 8,
  ScaleModels = 9,
  Stamps = 10,
  FunkoPop = 11,
  VinylRecords = 12,
  MusicalInstruments = 13,
  Autographs = 14,
  Perfumes = 15,
  Cars = 16,
  Comics = 17,
  Postcards = 18,
  Weapons = 19,
  MagicTheGathering = 20,
  Pokemon = 21,
  SportsCards = 22,
  Books = 23,
  Handbags = 24,
  Porcelain = 25,
  MoviePosters = 26,
  BoardGames = 27,
  Banknotes = 28,
  Phaleristics = 29,
  Other = 30,
  LegoMinifigures = 31,
  StarWarsCards = 32,
  LegoParts = 33,
  Riftbound = 34,
  Yugioh = 35,
  D_DMiniatures = 36,
  Heroclix = 37,
  WoW = 38,
  CardfightVanguard = 39,
  ForceOfWill = 40,
  DiceMasters = 41,
  FutureCardBuddyfight = 42,
  WeissSchwarz = 43,
  DragonBallZ = 44,
  FinalFantasy = 45,
  UniVersus = 46,
  StarWarsDestiny = 47,
  DragonBallSuper = 48,
  Dragoborne = 49,
  MetaX = 50,
  MyLittlePonyTCG = 51,
  Exodus = 52,
  Lightseekers = 53,
  Munchkin = 54,
  WarhammerAscTCG = 55,
  TransformersTCG = 56,
  Bakugan = 57,
  FleshAndBlood = 58,
  Digimon = 59,
  MetaZoo = 60,
  Wixoss = 61,
  OnePiece = 62,
  Lorcana = 63,
  BattleSpiritsSaga = 64,
  Shadowverse = 65,
  Akora = 66,
  GrandArchive = 67,
  Kryptik = 68,
  SorceryContestedRealm = 69,
  AlphaClash = 70,
  StarWarsUnlimited = 71,
  DragonBallSuperFusionWorld = 72,
  UnionArena = 73,
  Elestrals = 74,
  PokemonJapan = 75,
  Gundam = 76,
  Godzilla = 77,
}

export const CategoryId_Schema = z.nativeEnum(CategoryId);

export const Category_Schema = z
  .object({
    id: CategoryId_Schema,
    url: z.string(),
    name: z.string(),
    isSearchable: z.boolean(),
    itemsOnMarketplace: WholeNumber_Schema,
  })
  .transform(({ itemsOnMarketplace, ...rest }) => ({
    ...rest,
    marketplaceItemsCount: itemsOnMarketplace,
  }));
